import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class InterceptorService {
    apiToken: any = '';
    constructor(private authService: AuthService) { }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.authService.getAuthToken() != "") {
            req = req.clone({
                setHeaders: {
                    'Authorization': `${this.authService.getAuthToken()}`,
                    'identifier': environment.IDENTIFIER,
                }
            });
        }
        else {
            req = req.clone({
                setHeaders: {
                    'accept': 'application/json'
                }
            });
        }
        return next.handle(req);
    }
}
